import { useEffect, useState } from 'react';
import { API_URL, buildKioskAuthHeaders } from './api';
import { befidAddonUrl, befidEntryAccess } from './befidAddonLinks';
import './BefidAddonEntry.css';

export default function BefidAddonEntry({ brand, returnTo = 'admin', page = 'admin' }) {
  const [state, setState] = useState('loading');
  const [attempt, setAttempt] = useState(0);
  const href = befidAddonUrl(brand, returnTo, page);
  useEffect(() => {
    const controller = new AbortController();
    setState('loading');
    if (!href) { setState('unavailable'); return () => controller.abort(); }
    fetch(`${API_URL}/api/fid/access`, { credentials: 'include', cache: 'no-store', headers: buildKioskAuthHeaders(), signal: controller.signal })
      .then(async response => {
        const data = await response.json().catch(() => null);
        if (controller.signal.aborted) return;
        if ([401, 402, 403].includes(response.status)) { setState('denied'); return; }
        if (!response.ok) throw new Error('Unavailable');
        setState(befidEntryAccess(data, page) ? 'allowed' : 'denied');
      })
      .catch(() => { if (!controller.signal.aborted) setState('unavailable'); });
    const refresh = () => { controller.abort(); setAttempt(value => value + 1); };
    window.addEventListener('focus', refresh); window.addEventListener('storage', refresh);
    return () => { controller.abort(); window.removeEventListener('focus', refresh); window.removeEventListener('storage', refresh); };
  }, [href, page, attempt]);
  return <section className="befid-addon-entry" aria-label="Fidélisation BEFID">
    <strong>Fidélisation BEFID</strong>
    {state === 'allowed' ? <a href={href} target="_blank" rel="noopener noreferrer">{page === 'tablet' ? 'Ouvrir l’écran BEFID' : 'Ouvrir la gestion BEFID'} ↗</a>
      : <><button type="button" disabled>Ouvrir BEFID</button><p role="status">{state === 'loading' ? 'Vérification de l’accès…' : state === 'denied' ? 'Cet accès BEFID n’est pas autorisé pour votre compte.' : 'Accès BEFID momentanément indisponible.'}</p>{state === 'unavailable' && href && <button type="button" onClick={() => setAttempt(value => value + 1)}>Réessayer</button>}</>}
  </section>;
}
